module.exports = __webpack_public_path__ + "img/magento-migration_small@2x.db034ba8.webp";